export default __webpack_public_path__ + "static/9-83e515bd4417c14d788e6a196b06c3b7.webp";